// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/experiment_parameter_overrides.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ExperimentPlexParameterOverrides } from "./experiment_plex_parameter_overrides_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_plex_parameter_overrides } from "./experiment_plex_parameter_overrides_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/experiment_parameter_overrides.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_experiment_parameter_overrides: GenFile = /*@__PURE__*/
  fileDesc("CkxxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvZXhwZXJpbWVudF9wYXJhbWV0ZXJfb3ZlcnJpZGVzLnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEiogEKHEV4cGVyaW1lbnRQYXJhbWV0ZXJPdmVycmlkZXMSFQoNZXhwZXJpbWVudF9pZBgBIAEoCRJrChhwbGV4X3BhcmFtZXRlcl9vdmVycmlkZXMYAiADKAsySS5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuRXhwZXJpbWVudFBsZXhQYXJhbWV0ZXJPdmVycmlkZXNiBnByb3RvMw", [file_quanterix_simoa_one_analysis_app_api_v1_experiment_plex_parameter_overrides]);

/**
 * Experiment analysis setup parameters to override assay defaults and exclude
 * replicate data points (e.g. outliers)
 *
 * @remarks Equivalent to the quanterix.protos.data_management.v1 type
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.ExperimentParameterOverrides
 */
export type ExperimentParameterOverrides = Message<"quanterix.simoa_one.analysis_app_api.v1.ExperimentParameterOverrides"> & {
  /**
   * Unique id (UUID) for the experiment containing these overrides
   *
   * @generated from field: string experiment_id = 1;
   */
  experimentId: string;

  /**
   * Per-plex parameter overrides for experiment configuration
   *
   * @generated from field: repeated quanterix.simoa_one.analysis_app_api.v1.ExperimentPlexParameterOverrides plex_parameter_overrides = 2;
   */
  plexParameterOverrides: ExperimentPlexParameterOverrides[];
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.ExperimentParameterOverrides.
 * Use `create(ExperimentParameterOverridesSchema)` to create a new message.
 */
export const ExperimentParameterOverridesSchema: GenMessage<ExperimentParameterOverrides> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_experiment_parameter_overrides, 0);

